const normalizeLabel = (text = "") =>
  String(text)
    .toLowerCase()
    .replace(/[.:]/g, "")
    .replace(/\s+/g, " ")
    .trim();

export const extractValueFromStatText = (text) => {
  const trimmed = String(text || "").trim();
  if (!trimmed) return { label: "", value: "" };

  const sepIndex = trimmed.indexOf(":");
  if (sepIndex !== -1) {
    return {
      label: trimmed.slice(0, sepIndex).trim(),
      value: trimmed.slice(sepIndex + 1).trim(),
    };
  }

  return { label: trimmed, value: "" };
};

export const buildHeroValueMap = (hero) => {
  const map = {};

  if (!hero) return map;

  Object.keys(hero)
    .filter((key) => /^stat_\d+$/.test(key))
    .forEach((key) => {
      const { label, value } = extractValueFromStatText(hero[key]);
      if (!label) return;

      const normalized = normalizeLabel(label);
      if (value) {
        map[normalized] = value;
      }
    });

  return map;
};

const OVERALL_MATCHERS = {
  1: ["maximum height", "height"],
  2: ["length"],
  3: ["length with storage", "storage box"],
  4: ["wheel base", "wheelbase"],
  5: ["width"],
};

const STORAGE_MATCHERS = {
  1: ["trunk volume", "trunk"],
  2: ["storage box"],
};

const HERO_STAT_BY_OVERALL = {
  voyahtaishan: {
    1: 9,
    2: 7,
    4: 5,
    5: 8,
  },
};

const HERO_STAT_BY_STORAGE = {};

export const getHeroStatValueByIndex = (hero, statNum) => {
  if (!hero || !statNum) return "";
  const { value } = extractValueFromStatText(hero[`stat_${statNum}`]);
  return value || "";
};

export const findHeroValue = (heroMap, matchers = []) => {
  for (const matcher of matchers) {
    const normalizedMatcher = normalizeLabel(matcher);

    for (const [key, value] of Object.entries(heroMap)) {
      if (key.includes(normalizedMatcher)) {
        return value;
      }
    }
  }

  return "";
};

export const resolveSpecValue = ({
  i18nValue,
  heroValue,
  apiValue,
}) => {
  const fromI18n = String(i18nValue || "").trim();
  if (fromI18n && !fromI18n.startsWith("voyah")) {
    return fromI18n;
  }

  const fromHero = String(heroValue || "").trim();
  if (fromHero) return fromHero;

  const fromApi = String(apiValue || "").trim();
  if (fromApi) return fromApi;

  return "";
};

export const buildMergedSpecItems = ({
  page,
  section,
  keys,
  t,
  i18nPrefix,
  hero,
  heroMap,
  apiSpecs,
}) => {
  const matchersBySection = section === "storage" ? STORAGE_MATCHERS : OVERALL_MATCHERS;
  const heroStatMap =
    section === "overall"
      ? HERO_STAT_BY_OVERALL[page] || {}
      : HERO_STAT_BY_STORAGE[page] || {};

  return keys
    .map((key) => {
      const label = t(`${i18nPrefix}.technicalSpecs.${section}.${key}.label`);
      const i18nValue = t(`${i18nPrefix}.technicalSpecs.${section}.${key}.value`);
      const apiValue = apiSpecs?.[`${section}_${key}_value`];

      if (!label || label.startsWith("voyah")) return null;

      const heroValue =
        getHeroStatValueByIndex(hero, heroStatMap[Number(key)]) ||
        findHeroValue(heroMap, matchersBySection[Number(key)] || []);

      return {
        label,
        value: resolveSpecValue({ i18nValue, heroValue, apiValue }),
      };
    })
    .filter(Boolean);
};
